<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="qualityControl-box">
      <div class="head-box">
        质控公告
      </div>
      <div class="center-box">
        <div class="qualityControl-box">
          <div class="crumbs">首页 > 质控公告</div>
        </div>
        <div class="title-nav">
          <div class="nav-li" v-for="(item, index) in navItems" :key="index" :class="{ active: activeIndex === item.id }" @click="setActive(item.id)">
            {{ item.name }}
          </div>
        </div>
        <announcement :announcement="announcement" />
        <el-pagination class="paging" background :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="prev, pager, next, sizes" :total="totalCount" @size-change="sizeChange"
          @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
        </el-pagination>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import announcement from "@/components/base/announcement";
import { getInformationType, getPageList } from '@/api/home'

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, announcement },
  data() {
    return {
      selectedIndex: 3,
      navItems: [], // 导航项
      activeIndex: '', // 默认激活第一个项
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      announcement: [],
    }
  },
  methods: {
    setActive(index) {
      this.activeIndex = index; // 设置当前激活的项
      this.getPageList()
    },
    gotoNews() {
      this.$router.push('/NewsCenter')
    },
    // 列表查询资讯类型
    async getInformationType() {
      await getInformationType({
        categories: 'NOTICE',
      }).then(res => {
        this.navItems = res.data
        this.activeIndex = res.data.length > 0 ? res.data[0].id : ''
      })
    },
    // 分页查询新闻资讯、质控课程、质控公告
    async getPageList() {
      await getPageList({
        number: this.currentPage,
        limit: this.pageSize,
        checkStatus: 'HAVE_RELEASED',
        categories: 'NOTICE',
        type: this.activeIndex
      }).then(res => {
        this.announcement = res.data
        this.totalCount = res.totalCount
      })
    },
    async Initialization() {
      await this.getInformationType()
      await this.getPageList()
    },
    sizeChange(value) {
      this.pageSize = value
      this.currentPage = 1
      this.getPageList()
    },
    currentChange(value) {
      this.currentPage = value
      this.getPageList()
    },
    prevClick(value) {
      this.currentPage = value
      this.getPageList()
    },
    nextClick(value) {
      this.currentPage = value
      this.getPageList()
    },
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    this.Initialization()
  }
}
</script>

<style lang="less" scoped>
.title-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  margin-bottom: 22px;

  .nav-li {
    margin: 0 20px;
  }
}

.head-box {
  background: url("~@/assets/images/b3.png") no-repeat;
  background-size: 100% 100%;
  color: #fff;
}

.center-box {
  padding-bottom: 80px;
}

/deep/.el-input__inner {
  height: 32px;
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/QualityControl/index.vue